// extracted by mini-css-extract-plugin
module.exports = {"app__footer":"s_bb","app__footer__copyFoot":"s_bc"};